import { branchRoutes } from "./RouteExports/branchRoutes";
import { CRGroutes } from "./RouteExports/CRGroutes";
import { dashboardRoutes } from "./RouteExports/dashboardRoutes";
import { generalRoutes } from "./RouteExports/generalRoutes";

export default {
  routes: [...dashboardRoutes,  ...CRGroutes, ...branchRoutes, ...generalRoutes],
  otherRoutes: [],
};
